export default {
  'workOrder.home.welcome': '欢迎使用',
  'workOrder.common.create': '新建工单',
  'workOrder.common.refresh': '刷新数据',
  'workOrder.common.reload': '重新加载',
  'workOrder.common.view': '查看',
  'workOrder.common.all': '全部',
  'workOrder.common.none': '暂无数据',
  'workOrder.status.pending_accept': '待受理',
  'workOrder.status.processing': '处理中',
  'workOrder.status.pending_confirm': '待确认',
  'workOrder.status.closed': '已办结',
  'workOrder.status.cancelled': '已取消',
  'workOrder.priority.low': '低',
  'workOrder.priority.normal': '普通',
  'workOrder.priority.high': '高',
  'workOrder.priority.critical': '紧急',
  'workOrder.list.title.all': '全部工单',
  'workOrder.list.title.todo': '我的待办',
  'workOrder.list.title.mine': '我的工单',
  'workOrder.list.ticketNo': '编号',
  'workOrder.list.workOrderTitle': '标题',
  'workOrder.list.priority': '优先级',
  'workOrder.list.status': '状态',
  'workOrder.list.createdAt': '创建时间',
  'workOrder.list.actions': '操作',
  'workOrder.create.title': '新建工单',
  'workOrder.create.titleWithTemplate': '新建 {name}',
  'workOrder.create.submit': '提交工单',
  'workOrder.create.submitted': '工单已提交',
  'workOrder.create.basicInfo': '基础信息',
  'workOrder.create.extendedInfo': '扩展信息',
  'workOrder.create.template': '工单模板',
  'workOrder.create.templateRequired': '请选择工单模板',
  'workOrder.create.workOrderTitle': '工单标题',
  'workOrder.create.titleRequired': '请输入工单标题',
  'workOrder.template.title': '工单模板',
  'workOrder.template.create': '新建模板',
  'workOrder.template.name': '模板名称',
  'workOrder.template.code': '模板编码',
  'workOrder.template.currentVersion': '当前版本',
  'workOrder.template.unpublished': '未发布',
  'workOrder.template.status': '状态',
  'workOrder.template.draft': '草稿',
  'workOrder.template.published': '已发布',
  'workOrder.template.enabled': '启用',
  'workOrder.template.disabled': '停用',
  'workOrder.template.lastPublishedAt': '最近发布时间',
  'workOrder.template.configure': '配置',
  'workOrder.template.copy': '复制',
  'workOrder.template.copied': '模板已复制',
  'workOrder.form.uploadAttachment': '上传附件',
  'workOrder.puck.options': '选项列表，每行一个，格式为显示名|编码',
  'workOrder.puck.code': '系统编码',
  'workOrder.puck.label': '显示名称',
  'workOrder.puck.helpText': '帮助文本',
  'workOrder.puck.placeholder': '占位提示',
  'workOrder.puck.required': '是否必填',
  'workOrder.puck.no': '否',
  'workOrder.puck.yes': '是',
  'workOrder.puck.initiatePermission': '发起阶段',
  'workOrder.puck.processPermission': '处理阶段',
  'workOrder.puck.editable': '可编辑',
  'workOrder.puck.readonly': '只读',
  'workOrder.puck.hidden': '隐藏',
  'workOrder.puck.conditionFieldCode': '条件字段编码',
  'workOrder.puck.conditionOperator': '条件操作',
  'workOrder.puck.equals': '等于',
  'workOrder.puck.notEquals': '不等于',
  'workOrder.puck.contains': '包含',
  'workOrder.puck.notEmpty': '不为空',
  'workOrder.puck.conditionValue': '条件值',
  'workOrder.puck.attachmentAccept': '允许类型',
  'workOrder.puck.attachmentSize': '单文件大小（MB）',
  'workOrder.puck.attachmentCount': '最多文件数',
  'workOrder.puck.selectFile': '选择文件',
  'workOrder.puck.fields': '工单字段',
  'workOrder.puck.layouts': '布局组件',
  'workOrder.puck.text': '单行文本',
  'workOrder.puck.textarea': '多行文本',
  'workOrder.puck.number': '数字',
  'workOrder.puck.select': '单选',
  'workOrder.puck.multiSelect': '多选',
  'workOrder.puck.date': '日期',
  'workOrder.puck.dateRange': '日期范围',
  'workOrder.puck.member': '成员选择',
  'workOrder.puck.attachment': '附件',
  'workOrder.puck.switch': '开关',
  'workOrder.puck.oneColumn': '一列布局',
  'workOrder.puck.twoColumn': '两列布局',
  'workOrder.puck.layoutName': '布局名称',
  'workOrder.puck.group': '分组',
  'workOrder.puck.groupName': '分组名称',
  'workOrder.puck.fieldGroup': '字段分组',
  'workOrder.editor.publishCheckFailed': '发布检查未通过',
  'workOrder.editor.published': '模板已发布',
  'workOrder.editor.draftSaved': '草稿已保存',
  'workOrder.editor.publishFailed': '模板发布失败，请稍后重试',
  'workOrder.editor.draftSaveFailed': '草稿保存失败，请稍后重试',
  'workOrder.editor.editTitle': '编辑模板',
  'workOrder.editor.saveDraft': '保存草稿',
  'workOrder.editor.publish': '发布模板',
  'workOrder.editor.basicInfo': '基本信息',
  'workOrder.editor.formDesign': '表单设计',
  'workOrder.editor.workflow': '流程配置',
  'workOrder.editor.sla': 'SLA 配置',
  'workOrder.editor.publishCheck': '发布检查',
  'workOrder.editor.nameRequired': '请输入模板名称',
  'workOrder.editor.codeInvalid': '编码只能使用小写字母、数字和下划线',
  'workOrder.editor.description': '模板说明',
  'workOrder.editor.statCategory': '统计分类',
  'workOrder.editor.enabled': '启用状态',
  'workOrder.editor.preview': '实时预览',
  'workOrder.editor.deleteNode': '删除节点',
  'workOrder.editor.nodeCode': '节点编码',
  'workOrder.editor.nodeName': '节点名称',
  'workOrder.editor.nodeType.accept': '受理',
  'workOrder.editor.nodeType.process': '处理',
  'workOrder.editor.nodeType.ownerConfirm': '负责人确认',
  'workOrder.editor.nodeType.requesterConfirm': '发起人确认',
  'workOrder.editor.assignee.member': '指定成员',
  'workOrder.editor.assignee.role': '组织角色',
  'workOrder.editor.assignee.group': '候选组',
  'workOrder.editor.selectAssignee': '选择负责人',
  'workOrder.editor.assigneeCode': '负责人编码',
  'workOrder.editor.responseMinutes': '响应分钟',
  'workOrder.editor.processMinutes': '处理分钟',
  'workOrder.editor.requiresResult': '要求处理结果',
  'workOrder.editor.addNode': '新增节点',
  'workOrder.editor.warningLeadTime': '预警提前量',
  'workOrder.editor.minutes': '{value} 分钟',
  'workOrder.editor.hour': '1 小时',
  'workOrder.editor.recheck': '重新检查',
  'workOrder.editor.emptyChecks': '点击重新检查生成检查结果',
  'workOrder.editor.passed': '通过',
  'workOrder.editor.failed': '未通过',
  'workOrder.editor.previous': '上一步',
  'workOrder.editor.next': '下一步',
};
